<template src="./html/Index.html"></template>

<script>
	import swal from 'sweetalert2'
	import Datatable from './Datatable.vue'
	export default {
		props: ['user', 'isAuth'],
		components: {
			'datatable': Datatable,
		},
		data () {
			return {
			}
		},
		methods: {
			reload() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/cms/articles/views/Index.vue